export default __webpack_public_path__ + "static/media/arch_des_zh.b2714190.png";